module.exports = __webpack_public_path__ + "img/116.6ef45921.jpg";